// extracted by mini-css-extract-plugin
export var form = "_g0-0";